import { CompanyRole } from "@/lib/miscellaneous/authorization";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$company/")({
  beforeLoad: async ({ params, context }) => {
    const company = context.companies;

    if (!company) return;

    const user = context.auth.session?.user;
    const userInCompany = company.users?.find(
      (u: any) => u.userId === user?.userId,
    );
    const role = userInCompany?.companyRole;

    const isClient = role === CompanyRole.CLIENT;

    throw redirect({
      to: isClient ? "/$company/unternehmen" : "/$company/buchhaltung",
      params: { company: params.company },
      replace: true,
    });
  },
});
